export const frontendURI = '/cat/interviewers/';
export const backendURI = `/api${frontendURI}`;
